document.addEventListener('DOMContentLoaded', function () {
    const folders = document.querySelectorAll('.folder')
    if (folders.length === 0) return
    const select = document.querySelector('#document-filters')
    if (!select) return
    const searchInput = document.querySelector('#product-document-search')
    if (!searchInput) return

    // Skapa default-val
    const defaultOption = new Option('-- Select category --', '')
    select.appendChild(defaultOption)

    const addedSlugs = new Set()

    folders.forEach((folder) => {
        const category = folder.dataset.category
        const label = folder.querySelector('.folder-name')?.textContent.trim()

        if (category && label && !addedSlugs.has(category)) {
            select.appendChild(new Option(label, category))
            addedSlugs.add(category)
        }
    })

    // Händelse: filter via select
    select.addEventListener('change', () => {
        const selectedCategory = select.value
        searchInput.value = '' // nollställ söken

        // Visa/dölj folders
        folders.forEach((folder) => {
            const match = selectedCategory === '' || folder.dataset.category === selectedCategory
            folder.style.display = match ? '' : 'none'
        })

        // Visa alla dokument
        document.querySelectorAll('.product-document-item').forEach((item) => item.classList.remove('hidden'))

        // Stäng alla sub-folders
        document.querySelectorAll('.sub-folder').forEach((folder) => {
            folder.classList.remove('hidden')
            folder.removeAttribute('open')
        })
    })

    // Händelse: live-sökning
    searchInput.addEventListener('keyup', (e) => {
        const searchText = searchInput.value.toUpperCase()

        if (searchText.length > 0) {
            select.value = ''
            folders.forEach((folder) => (folder.style.display = ''))
        }

        updateVisibility(searchText)

        if (e.key === 'Enter') {
            document.querySelector('.product-document-search-btn').click()
        }
    })

    function updateVisibility(searchText) {
        const items = document.querySelectorAll('.product-document-item')

        if (searchText === '') {
            // Visa allt igen
            items.forEach((item) => item.classList.remove('hidden'))

            document.querySelectorAll('.sub-folder').forEach((folder) => {
                folder.classList.remove('hidden')
                folder.removeAttribute('open')
            })

            document.querySelector('#product-documents').scrollIntoView({ behavior: 'smooth' })

            return
        }

        // Filtrera dokument
        items.forEach((item) => {
            const textMatch = item.textContent.toUpperCase().includes(searchText)
            item.classList.toggle('hidden', !textMatch)
        })

        // Visa rätt foldrar
        document.querySelectorAll('.sub-folder').forEach((folder) => {
            const visibleDocs = folder.querySelectorAll('.product-document-item:not(.hidden)')
            const isVisible = visibleDocs.length > 0

            folder.classList.toggle('hidden', !isVisible)

            // Remove any existing first-visible-doc IDs in this folder
            folder.querySelectorAll('#first-visible-doc').forEach((doc) => {
                doc.removeAttribute('id')
            })

            if (isVisible) {
                folder.setAttribute('open', 'open')
                // Set ID on first visible doc in this folder
                visibleDocs[0].setAttribute('id', 'first-visible-doc')
            } else {
                folder.removeAttribute('open')
            }
        })
    }
})
